import type {SlotGameStore} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";

class GameSymbolView extends SlotGame.src.component.ReelsetComponent.src.SymbolView {
    counter: number;

    async playLanding(): Promise<any> {
        if(this.store.gameData.bonusGame.isPlaying()) return;

        return super.playLanding();
    }

    public setOverlayView(newValue = null) {
        if (!GameSymbolView.bonusGameConfig.coinSymbolIds.includes(this.id)) return;

        const textConfigView = ReelsetComponent.src.SymbolView.symbolTextConfig.view;
        this.removeOverlayView();
        this.overlayView = game.builder.create(textConfigView);

        let value = this.store.gameData.reels[this.reelId][this.rowId]?.value;

        if (this.rowId < 0) {
            const randomValueIndex = Math.floor(Math.random() * (ReelsetComponent.src.SymbolView.bonusGameConfig.fakeValues.length - 1));
            value = ReelsetComponent.src.SymbolView.bonusGameConfig.fakeValues[randomValueIndex];
        }

        if (!value) return;

        // silver and gold coin logic
        if (newValue) {
            if (this.id !== CONST.SYMBOLS.COIN) {
                this.overlayView.options.text = newValue;
            } else {
                return;
            }
        } else {
            if (this.id === CONST.SYMBOLS.COIN || this.counter) {
                this.overlayView.options.text = this.store.toFormatMoney(value * this.store.gameData.bet);
            } else {
                return;
            }
        }

        this.overlayView.updateViewOptions();
        this.view.addChild(this.overlayView);

        // jackpot only on bronze coin
        if (this.id == CONST.SYMBOLS.COIN) {
            if (String(value) === CONST.JACKPOT.GOLD.multiplier.toString()) {
                this.setOverlayImage(`coin_${CONST.JACKPOT.GOLD.name}`);
                return;
            } else if (String(value) === CONST.JACKPOT.SILVER.multiplier.toString()) {
                this.setOverlayImage(`coin_${CONST.JACKPOT.SILVER.name}`);
                return;
            } else if (String(value) === CONST.JACKPOT.BRONZE.multiplier.toString()) {
                this.setOverlayImage(`coin_${CONST.JACKPOT.BRONZE.name}`);
                return;
            }
        }
    }

    setOverlayImage(name, scale = { x: 1, y: 1 }) {
        this.removeOverlayView();
        this.overlayView = game.builder.create({type: "Sprite", texture: name, scale: scale});
        this.overlayView.updateViewOptions();
        this.view.addChild(this.overlayView);
    }

    public removeOverlayView() {
        const destroy = (container) => {
            if (!container) return;

            if (container.parent) {
                container.parent.removeChild(container);
            }

            container.destroy({
                children: true,
                texture: false,
                baseTexture: false
            });
            game.tree.handleChildChanged();
        }

        destroy(this.overlayView);
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
}

SlotGame.src.component.ReelsetComponent.src.SymbolView = GameSymbolView;